import React, { FC } from 'react';
import ArrowUpwardSharpIcon from '@material-ui/icons/ArrowUpwardSharp';
import CloseIcon from '@material-ui/icons/Close';

import Styled from './style';
import { Typography } from '../../../../shared/typography';
import colors from '../../../../assets/colors';
import useHook from './hook';
import { Message } from '../../../SnapSharedPage/components/message';
import RoundImg from '../../../../shared/avatar';

type IProps = {
	closeChat(): void;
	addComment?(text: string, user: any): void;
	item: any;
};

const Comments: FC<IProps> = ({ item, closeChat }) => {
	const { state, messagesEndRef, user, sections, handleChange, onSendComment } =
		useHook({ item });

	const { avatar, firstName, lastName } = user;
	const fullName = `${firstName || ''} ${lastName || ''}`;

	const { comment } = state;

	return (
		<Styled.Wrapper>
			<Styled.Header>
				<div style={{ marginRight: 12 }}>
					<Typography text={'Сhat'} size="normal" color="black" type="bold" />
				</div>
				<Styled.Close onClick={closeChat}>
					<CloseIcon style={{ color: colors.black }} />
				</Styled.Close>
			</Styled.Header>
			<Styled.TopContent>
				<Styled.Block>
					{sections.length ? (
						sections.map((section: any, i: number) => (
							<div key={i}>
								<Styled.SectionTitle>
									<Typography
										text={section.title}
										size="medium"
										color="btnTextGrey"
									/>
								</Styled.SectionTitle>
								{section.data.map((message: any, i: any) => (
									<Message
										key={i}
										item={message}
										mine={message.userId === user?._id}
									/>
								))}
							</div>
						))
					) : (
						<Styled.SectionTitle>
							<Typography
								text={'No comments'}
								size="medium"
								color="btnTextGrey"
							/>
						</Styled.SectionTitle>
					)}
					<div ref={messagesEndRef} style={{ float: 'left', clear: 'both' }} />
				</Styled.Block>
			</Styled.TopContent>
			<Styled.BottomContent>
				<div style={{ marginRight: 12 }}>
					<RoundImg avatar={avatar} size={49} name={fullName} />
				</div>
				<Styled.Input
					placeholder={'Comment...'}
					onChange={handleChange}
					value={comment}
				/>
				<Styled.Button onClick={onSendComment} active={!!comment.trim()}>
					<ArrowUpwardSharpIcon
						style={{ color: colors.white }}
						fontSize="large"
					/>
				</Styled.Button>
			</Styled.BottomContent>
		</Styled.Wrapper>
	);
};

export default Comments;
